import { memeGeneratorSlice } from "./memeGeneratorSlice";

export const {
    setMeme,
    setMemeInfo,
    setSettings,
    setLoaded,
    setActiveTextBoxId,
    setRecentlyUsedFonts,
    appendToRecentlyUsedFonts,
    setIsLoadingRecentlyUsedFonts,
    applySettingsToAll,
    deleteTextBox,
    addTextBox,
    setPadding,
    deletePadding,
    addIcon,
    removeIcon,
    setIconSettings,
    editIcon,
    setActiveIconId,
    editIconDraggingState,
} = memeGeneratorSlice.actions;
